import React from 'react';
import { useSelector } from "react-redux";
import { CheckWhiteIcon } from '../../assets/imageAssets';

const SubscriptionCanceledModal = ({modalData}) => {
    const user = useSelector((state) => state.me.data);
    const premiumEnd = user?.user_premium_status?.premium_access_until
        ? new Date(user.user_premium_status.premium_access_until).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        : null;
    const pausedUntil = user?.user_premium_status?.pause_until
        ? new Date(user.user_premium_status.pause_until).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        : null;
    
    const isPause = modalData?.type === 'pause';

    return (
        <>
            <div className="modal-body">
                <div className='icon success'>
                    <img src={CheckWhiteIcon} alt="Check Icon" />
                </div>
                <h2 className='mb-8'>{isPause ? 'Subscription Paused' : 'Subscription Canceled'}</h2>
                <p className='mb-24'>
                    {isPause 
                        ? <>
                            Your subscription has been paused.
                            {/* It will resume automatically on <strong>{pausedUntil || 'N/A'}</strong>. */}
                          </>
                        : <>Your subscription has been successfully canceled. After <strong>{premiumEnd || 'N/A'}</strong>, your account will switch to the Free Plan.</>
                    }
                </p>
                {/* <button className='primary-button'>Resubscribe</button> */}
            </div>
        </>
    );
}

export default SubscriptionCanceledModal;